module.exports = __webpack_public_path__ + "img/nav-right-with-contact-black-lincoln.acee7fda.png";